import styled from "styled-components";
import {
  getColor,
  getFadeInAnimation,
  getSize,
  responsive,
} from "~/helpers/style";
import { sidebarMobileHeight, sidebarWidth } from "./Sidebar.style";
import { UIProps } from "~/types/style";

interface IPageWrapper extends UIProps {
  padding: string;
}

export const PageWrapper = styled.div<IPageWrapper>`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100vw;
  left: 0;
  top: ${sidebarMobileHeight}px;
  padding: ${getSize(1)} ${getSize(2)} ${getSize(2)};
  position: relative;
  background-color: ${getColor("background")};
  ${getFadeInAnimation(0.2)}

  ${responsive("laptop")} {
    padding: ${({ padding }) => padding};
  }
  ${responsive("tablet")} {
    width: calc(100vw - ${sidebarWidth}px);
    top: 0;
    left: ${sidebarWidth}px;
  }
`;

export const PageWrapperFullscreen = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100vw;
  background-color: ${getColor("background")};
  ${getFadeInAnimation(0.2)}
`;

export const PageMaxWidth = styled.div`
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  display: flex;
  direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-left: auto;
`;
